import { getAdapterApiUrl } from '../api-adapter/api-adapter'
import side from '../../../util/side/side'
import { getConfig } from '../config/config'
import { StatusCodes } from 'http-status-codes'

export const getApiUrl = (uri: string): string => {
  const hostname = getAdapterApiUrl()
  return `${hostname}${uri}`
}

export type ApiCallResponseType<T> = {
  status: StatusCodes
  data: T
}

export const getUrl = (uri: string): string => {
  const { CLIENT_API_ADAPTER_URL } = getConfig()
  const hostname = side() === 'client' ? CLIENT_API_ADAPTER_URL : 'http://localhost:3000'
  return `${hostname}${uri}`
}

export const getDPGApiUrl = (uri: string): string => `${getConfig().API_URL}${uri}`

export const getProfileApiUrl = (uri: string): string => `${getConfig().PROFILE_API_URL || ''}${uri}`

export const getMailServiceUrl = (uri: string): string => `${getConfig().MAILSERVICE_URL}${uri}` || ''

export const BASE_NEXT_API = '/dashboard/api'

export const CREDITS_API_URL = `${BASE_NEXT_API}/credits`
export const DASHBOARD_API_URL = `${BASE_NEXT_API}/dashboard`
export const PAYMENT_API_URL = `${BASE_NEXT_API}/payment`
export const PAYMENT_WEBSHOP_URL = `${BASE_NEXT_API}/webshop`
export const RECRUITER_API_URL = `${BASE_NEXT_API}/recruiter`
export const PERFORMANCE_BASED_JOB_API_URL = `${BASE_NEXT_API}/job/performance-based`
export const PRICING_API_URL = `${BASE_NEXT_API}/pricing`
export const JOBS_API_URL = `${BASE_NEXT_API}/jobs`
export const PERFORMANCE_API_URL = `${BASE_NEXT_API}/performance`
export const PRODUCTS_API_URL = `${BASE_NEXT_API}/products`
export const JOB_API_URL = '/api/v1/job'
export const LOCATION_ADDRESSES_API_URL = '/api/v1/addresses/nl'
export const JOBS_PERFORMANCE_API_URL = `${JOBS_API_URL}/performance`

export const JOBTITLE_API_URL = '/jobtitle'
export const MAIL_API_URL = '/mail'

export const PROFILE_API_JOBSEEKER_URL = '/recruiter/job-seeker'
export const PROFILE_API_RECRUITER_ME = '/recruiter/me'

export const SALARY_SUGGESTION_API = '/historical/salaryStatistics'
